import React, { useEffect, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  PUserPageTitle,
  UserPageTitle,
} from 'src/features/user/common/UserPageTitle';
import { UserPageCard } from 'src/features/user/common/UserPageCard';
import { GuestMenuTabs } from './GuestMenuTabs';
import { useHistory, useLocation } from 'react-router';
import { BaseButton } from 'src/components/common';
import SaveIcon from 'src/components/common/svgIcons/SaveIcon';
import { useDeviceSizeType } from 'src/utils/hooks/useDeviceType';

const useStyles = makeStyles(() => ({
  tabsContainer: {
    width: '100%',
    padding: '16px 24px',
    background: '#FFFFFF',
    borderRadius: '10px 10px 0 0'
  },
  wrapper: {
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: "0px 1px 2px -1px #0000001A",
    // boxShadow: 0px 1px 3px 0px #0000001A,

  }
}));

type PGuestsLayout = Partial<PUserPageTitle>;

export const GuestsLayout: React.FC<PGuestsLayout & {
  saveRef: React.MutableRefObject<null>
}> = (props) => {
  const { 
    title = 'Guests',
    description = 'New contacts appear here. These contacts are visible only to you.', 
    saveRef,
    children
   } = props;
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState('');
  const location = useLocation();
  const history = useHistory();
  const { isMobile } = useDeviceSizeType();
  const [isCreateForm, setisCreateForm] = useState(false);

  useEffect(() => {
    setCurrentTab(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    setisCreateForm(currentTab === "/guests/new-guest/create");
  }, [currentTab]);
  return (

    <UserPageCard>
      <div style={{
        display: "flex",
        alignItems: "center",
      }}>
        <UserPageTitle title={title} description={description}/>
        {isCreateForm && <BaseButton
          size="small"
          variant="contained"
          color="primary"
          className='button save'
          ref={saveRef}
          onClick={() => {
            saveRef?.current?.submit();
          }}
          style={{
            background: "#34C759"
          }}
        >
          <SaveIcon size={16} />
          {!isMobile && <span style={{
            fontWeight: 500,
            marginLeft: "9px",
          }}>Save</span>}
        </BaseButton>}
      </div>
      <div className={classes.wrapper}>
        <GuestMenuTabs
          className={classes.tabsContainer}
          onChange={(value) => history.push(String(value))}
          value={currentTab}
        />
        <div>{children}</div>
      </div>
    </UserPageCard>
  );
};
